import {ActionReducer, createReducer, on} from '@ngrx/store';
import {setBeDevVersion, setDevVersionData, setFeDevVersion, setUseDevEnvironment, setRegion} from './dev-version.actions';
import {DevVersionData} from '../../core/dev-versions/dev-version-data';

export interface AppContainer {
  devVersionData: DevVersionData;
  beDevVersion: string;
  region: string;
  feDevVersion: string;
  useDevEnvironment: boolean;
}

export const initialState: AppContainer = {
  devVersionData: null,
  beDevVersion: 'prod',
  region: 'global',
  feDevVersion: null,
  useDevEnvironment: false
};

export const devVersionReducer: ActionReducer<AppContainer> = createReducer(
  initialState,
  on(setDevVersionData, (state, {devVersionData}) => {
    return {...state, devVersionData: devVersionData};
  }),
  on(setBeDevVersion, (state, {beDevVersion}) => {
    return {...state, beDevVersion: beDevVersion};
  }),
  on(setRegion, (state, {region: region}) => {
    return {...state, region: region};
  }),
  on(setFeDevVersion, (state, {feDevVersion}) => {
    return {...state, feDevVersion: feDevVersion};
  }),
  on(setUseDevEnvironment, (state, {useDevEnvironment}) => {
    return {...state, useDevEnvironment: useDevEnvironment};
  })
);
